import { render, staticRenderFns } from "./ResultDisplay.vue?vue&type=template&id=30ef1f68&scoped=true&"
import script from "./ResultDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDisplay.vue?vue&type=style&index=0&id=30ef1f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef1f68",
  null
  
)

component.options.__file = "ResultDisplay.vue"
export default component.exports